import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly apiUrl = `${environment.apiUrl}`;
  private userSubject = new BehaviorSubject<any>(this.getUserFromStorage());
  
  constructor(private http: HttpClient) { }

  login(credentials: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/login`, credentials).pipe(
      switchMap(res => {
        const token = res.token;
        localStorage.setItem('os_token', token);
        
        return this.getUserInfo();
      }),
      tap(userInfoRes => {
        if (userInfoRes.success) {
          localStorage.setItem('os_user', JSON.stringify(userInfoRes.user));
          this.userSubject.next(userInfoRes.user);
        }
      })
    );
  }

  getUserInfo(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/me`);
  }

  logout() {
    return this.http.post(`${this.apiUrl}/logout`, {}).pipe(
      tap(() => {
        localStorage.removeItem('os_token');
        localStorage.removeItem('os_user');
        this.userSubject.next(null);
      })
    );
  }

  getToken(): string | null {
    return localStorage.getItem('os_token');
  }

  getUser() {
    const user = localStorage.getItem('os_user');
    return user ? JSON.parse(user) : null;
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
  
  hasFullAccess(): boolean {
    const data = this.getUser();
    if (!data) return false;

    return data.tipo === 'admin' || data.acesso_fluxo_caixa === 'all';
  }
  
  notifyLogin(user: any) {
    this.userSubject.next(user);
  }
  
  getUserFromStorage() {
    const user = localStorage.getItem('os_user');
    return user ? JSON.parse(user) : null;
  }
  
  onUserChange(): Observable<any> {
    return this.userSubject.asObservable();
  }
}